/**
 * Aviso da tela de login depois de uma saída que a pessoa NÃO pediu nesta aba (D5, D7).
 *
 * Transporte: `sessionStorage` (por aba, sobrevive ao `location.assign` da própria aba)
 * com uma CHAVE conhecida — nunca texto livre e nunca querystring: link com
 * `?motivo=<texto>` mostraria mensagem forjada na tela de login. Lido UMA vez:
 * `consumirAvisoDeLogin` apaga ao ler, então o F5 não repete.
 */
export const MOTIVOS_SAIDA = ['saiu', 'encerrada'] as const
export type MotivoSaida = (typeof MOTIVOS_SAIDA)[number]

export function ehMotivoSaida(valor: unknown): valor is MotivoSaida {
  return typeof valor === 'string' && (MOTIVOS_SAIDA as readonly string[]).includes(valor)
}

export const AVISO_LOGIN: Record<MotivoSaida, string> = {
  saiu: 'Você saiu em outra aba.',
  encerrada: 'Sua sessão foi encerrada. Entre de novo.',
}

const CHAVE_AVISO = 'login:aviso'

export function marcarAvisoDeLogin(motivo: MotivoSaida): void {
  sessionStorage.setItem(CHAVE_AVISO, motivo)
}

/** Lê e APAGA. Valor fora das chaves conhecidas é descartado (D7). */
export function consumirAvisoDeLogin(): MotivoSaida | null {
  const valor = sessionStorage.getItem(CHAVE_AVISO)
  sessionStorage.removeItem(CHAVE_AVISO)
  return ehMotivoSaida(valor) ? valor : null
}
